export default str => str.replace(/([a-z][A-Z])/g, g => `${g[0]}-${g[1].toLowerCase()}`);
